import React, { FC } from "react";

const PageTitle: FC<{ title: string }> = ({ title }) => {
  return <div className="fs-30px  fw-medium mb-5">{title}</div>;
};

export default PageTitle;
